export default __webpack_public_path__ + "assets/images/daf8fe948e450369f9c4cdabc823c81e.png";